import { Divider } from "../../divider/Divider";

export function InnerContentDivider() {
  return <Divider inset="space-4" />;
}
